import { styled } from '@linaria/react'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const AudioAutoQualitySC = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  border-radius: 8px;
`

export const AudioAutoQualityBodySC = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: var(${FIXED_INDENTS.INDENT_10});
  background: var(${COLOR.SURFACE_DARK_2});
  margin: var(${FIXED_INDENTS.INDENT_40}) 0 var(${FIXED_INDENTS.INDENT_30}) 0;
  gap: var(${FIXED_INDENTS.INDENT_10});
  border-radius: 8px;

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_20});
    margin: var(${FIXED_INDENTS.INDENT_50}) 0 var(${FIXED_INDENTS.INDENT_40}) 0;
  }

  ${MEDIA.MIN_1240} {
    margin-top: var(${FIXED_INDENTS.INDENT_60});
  }
`
